import { AfterContentInit, Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoaderService } from './core/services/loader.service';

import { ToastComponent } from './shared/toast/toast.component';
import { ToastService } from './shared/toast/toast.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  isLoading = this.loaderService.isLoading$;
  public href: any;
  showNavTopBar: boolean = true;
  showFooterBar: boolean = true;

  constructor(private router: Router, private loaderService: LoaderService, private toastService: ToastService) {
    this.href = window.location.href;

  }
  ngOnInit(): void {
    if (this.toastComponent) {
      this.toastService.register(this.toastComponent);
    }
  }

  ngAfterViewInit() {
    this.toastService.register(this.toastComponent);
  }

  private _isHome() {
    return !(this.router.url.includes("/registro")) ;
    // || this.router.url.includes("/login"));
  }
  private _showFooter() {
    return (
      !this.router.url.includes("/registro"));
  }
}
